/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DashboardRequest as BackendCoreApiModelsAppDashboardDashboardRequest } from '../models/Backend/Core/Api/Models/App/Dashboard/dashboard-request';
import { DashboardResponse as BackendCoreApiModelsAppDashboardDashboardResponse } from '../models/Backend/Core/Api/Models/App/Dashboard/dashboard-response';
import { DiscountedDashboardResponse as BackendCoreApiModelsAppDashboardDiscountedDashboardResponse } from '../models/Backend/Core/Api/Models/App/Dashboard/discounted-dashboard-response';
import { PppDashboardResponse as BackendCoreApiModelsAppDashboardPppDashboardResponse } from '../models/Backend/Core/Api/Models/App/Dashboard/ppp-dashboard-response';
import { InvoiceReportRequest as BackendCoreApiModelsAppReportsInvoiceReportRequest } from '../models/Backend/Core/Api/Models/App/Reports/invoice-report-request';
import { InvoiceReportResponse as BackendCoreApiModelsAppReportsInvoiceReportResponse } from '../models/Backend/Core/Api/Models/App/Reports/invoice-report-response';
import { PartnerProgramAssetRequest as BackendCoreApiModelsAppReportsPartnerProgramAssetRequest } from '../models/Backend/Core/Api/Models/App/Reports/partner-program-asset-request';
import { PartnerProgramAssetResponse as BackendCoreApiModelsAppReportsPartnerProgramAssetResponse } from '../models/Backend/Core/Api/Models/App/Reports/partner-program-asset-response';
import { PartnerProgramReportRequest as BackendCoreApiModelsAppReportsPartnerProgramReportRequest } from '../models/Backend/Core/Api/Models/App/Reports/partner-program-report-request';
import { PartnerProgramReportResponse as BackendCoreApiModelsAppReportsPartnerProgramReportResponse } from '../models/Backend/Core/Api/Models/App/Reports/partner-program-report-response';
import { RemainingOrderCollectionResponse as BackendCoreApiModelsAppReportsRemainingOrderCollectionResponse } from '../models/Backend/Core/Api/Models/App/Reports/remaining-order-collection-response';
import { SalesReportRequest as BackendCoreApiModelsAppReportsSalesReportRequest } from '../models/Backend/Core/Api/Models/App/Reports/sales-report-request';
import { SalesReportResponse as BackendCoreApiModelsAppReportsSalesReportResponse } from '../models/Backend/Core/Api/Models/App/Reports/sales-report-response';

@Injectable({
  providedIn: 'root',
})
export class AppReportBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDashboard
   */
  static readonly GetDashboardPath = '/api/app/report/dashboard';

  /**
   * Gets dashboard data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDashboard$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getDashboard$Plain$Response(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppDashboardDashboardResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetDashboardPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppDashboardDashboardResponse>;
      })
    );
  }

  /**
   * Gets dashboard data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDashboard$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getDashboard$Plain(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<BackendCoreApiModelsAppDashboardDashboardResponse> {

    return this.getDashboard$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppDashboardDashboardResponse>) => r.body as BackendCoreApiModelsAppDashboardDashboardResponse)
    );
  }

  /**
   * Gets dashboard data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDashboard$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getDashboard$Json$Response(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppDashboardDashboardResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetDashboardPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppDashboardDashboardResponse>;
      })
    );
  }

  /**
   * Gets dashboard data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDashboard$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getDashboard$Json(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<BackendCoreApiModelsAppDashboardDashboardResponse> {

    return this.getDashboard$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppDashboardDashboardResponse>) => r.body as BackendCoreApiModelsAppDashboardDashboardResponse)
    );
  }

  /**
   * Path part for operation getInvoiceReport
   */
  static readonly GetInvoiceReportPath = '/api/app/report/invoice';

  /**
   * Gets invoice report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoiceReport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getInvoiceReport$Plain$Response(params: {
    body: BackendCoreApiModelsAppReportsInvoiceReportRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsInvoiceReportResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetInvoiceReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsInvoiceReportResponse>;
      })
    );
  }

  /**
   * Gets invoice report.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInvoiceReport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getInvoiceReport$Plain(params: {
    body: BackendCoreApiModelsAppReportsInvoiceReportRequest
  }): Observable<BackendCoreApiModelsAppReportsInvoiceReportResponse> {

    return this.getInvoiceReport$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsInvoiceReportResponse>) => r.body as BackendCoreApiModelsAppReportsInvoiceReportResponse)
    );
  }

  /**
   * Gets invoice report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvoiceReport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getInvoiceReport$Json$Response(params: {
    body: BackendCoreApiModelsAppReportsInvoiceReportRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsInvoiceReportResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetInvoiceReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsInvoiceReportResponse>;
      })
    );
  }

  /**
   * Gets invoice report.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getInvoiceReport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getInvoiceReport$Json(params: {
    body: BackendCoreApiModelsAppReportsInvoiceReportRequest
  }): Observable<BackendCoreApiModelsAppReportsInvoiceReportResponse> {

    return this.getInvoiceReport$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsInvoiceReportResponse>) => r.body as BackendCoreApiModelsAppReportsInvoiceReportResponse)
    );
  }

  /**
   * Path part for operation getNormalPartnerDashboard
   */
  static readonly GetNormalPartnerDashboardPath = '/api/app/report/np-dashboard';

  /**
   * Gets Normal user dashboard data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNormalPartnerDashboard$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getNormalPartnerDashboard$Plain$Response(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppDashboardDiscountedDashboardResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetNormalPartnerDashboardPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppDashboardDiscountedDashboardResponse>;
      })
    );
  }

  /**
   * Gets Normal user dashboard data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getNormalPartnerDashboard$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getNormalPartnerDashboard$Plain(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<BackendCoreApiModelsAppDashboardDiscountedDashboardResponse> {

    return this.getNormalPartnerDashboard$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppDashboardDiscountedDashboardResponse>) => r.body as BackendCoreApiModelsAppDashboardDiscountedDashboardResponse)
    );
  }

  /**
   * Gets Normal user dashboard data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNormalPartnerDashboard$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getNormalPartnerDashboard$Json$Response(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppDashboardDiscountedDashboardResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetNormalPartnerDashboardPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppDashboardDiscountedDashboardResponse>;
      })
    );
  }

  /**
   * Gets Normal user dashboard data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getNormalPartnerDashboard$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getNormalPartnerDashboard$Json(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<BackendCoreApiModelsAppDashboardDiscountedDashboardResponse> {

    return this.getNormalPartnerDashboard$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppDashboardDiscountedDashboardResponse>) => r.body as BackendCoreApiModelsAppDashboardDiscountedDashboardResponse)
    );
  }

  /**
   * Path part for operation getPartnerProgramAsset
   */
  static readonly GetPartnerProgramAssetPath = '/api/app/report/pp-asset';

  /**
   * Gets Partner Program assets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerProgramAsset$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramAsset$Plain$Response(params: {
    body: BackendCoreApiModelsAppReportsPartnerProgramAssetRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramAssetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetPartnerProgramAssetPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramAssetResponse>;
      })
    );
  }

  /**
   * Gets Partner Program assets.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerProgramAsset$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramAsset$Plain(params: {
    body: BackendCoreApiModelsAppReportsPartnerProgramAssetRequest
  }): Observable<BackendCoreApiModelsAppReportsPartnerProgramAssetResponse> {

    return this.getPartnerProgramAsset$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramAssetResponse>) => r.body as BackendCoreApiModelsAppReportsPartnerProgramAssetResponse)
    );
  }

  /**
   * Gets Partner Program assets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerProgramAsset$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramAsset$Json$Response(params: {
    body: BackendCoreApiModelsAppReportsPartnerProgramAssetRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramAssetResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetPartnerProgramAssetPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramAssetResponse>;
      })
    );
  }

  /**
   * Gets Partner Program assets.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerProgramAsset$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramAsset$Json(params: {
    body: BackendCoreApiModelsAppReportsPartnerProgramAssetRequest
  }): Observable<BackendCoreApiModelsAppReportsPartnerProgramAssetResponse> {

    return this.getPartnerProgramAsset$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramAssetResponse>) => r.body as BackendCoreApiModelsAppReportsPartnerProgramAssetResponse)
    );
  }

  /**
   * Path part for operation getPartnerProgramDashboard
   */
  static readonly GetPartnerProgramDashboardPath = '/api/app/report/pp-dashboard';

  /**
   * Gets PartnerProgram dashboard data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerProgramDashboard$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramDashboard$Plain$Response(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppDashboardPppDashboardResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetPartnerProgramDashboardPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppDashboardPppDashboardResponse>;
      })
    );
  }

  /**
   * Gets PartnerProgram dashboard data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerProgramDashboard$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramDashboard$Plain(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<BackendCoreApiModelsAppDashboardPppDashboardResponse> {

    return this.getPartnerProgramDashboard$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppDashboardPppDashboardResponse>) => r.body as BackendCoreApiModelsAppDashboardPppDashboardResponse)
    );
  }

  /**
   * Gets PartnerProgram dashboard data.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerProgramDashboard$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramDashboard$Json$Response(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppDashboardPppDashboardResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetPartnerProgramDashboardPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppDashboardPppDashboardResponse>;
      })
    );
  }

  /**
   * Gets PartnerProgram dashboard data.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerProgramDashboard$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramDashboard$Json(params: {
    body: BackendCoreApiModelsAppDashboardDashboardRequest
  }): Observable<BackendCoreApiModelsAppDashboardPppDashboardResponse> {

    return this.getPartnerProgramDashboard$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppDashboardPppDashboardResponse>) => r.body as BackendCoreApiModelsAppDashboardPppDashboardResponse)
    );
  }

  /**
   * Path part for operation getPartnerProgramReport
   */
  static readonly GetPartnerProgramReportPath = '/api/app/report/pp-report';

  /**
   * Gets Partner Program report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerProgramReport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramReport$Plain$Response(params: {
    body: BackendCoreApiModelsAppReportsPartnerProgramReportRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramReportResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetPartnerProgramReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramReportResponse>;
      })
    );
  }

  /**
   * Gets Partner Program report.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerProgramReport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramReport$Plain(params: {
    body: BackendCoreApiModelsAppReportsPartnerProgramReportRequest
  }): Observable<BackendCoreApiModelsAppReportsPartnerProgramReportResponse> {

    return this.getPartnerProgramReport$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramReportResponse>) => r.body as BackendCoreApiModelsAppReportsPartnerProgramReportResponse)
    );
  }

  /**
   * Gets Partner Program report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerProgramReport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramReport$Json$Response(params: {
    body: BackendCoreApiModelsAppReportsPartnerProgramReportRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramReportResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetPartnerProgramReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramReportResponse>;
      })
    );
  }

  /**
   * Gets Partner Program report.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPartnerProgramReport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getPartnerProgramReport$Json(params: {
    body: BackendCoreApiModelsAppReportsPartnerProgramReportRequest
  }): Observable<BackendCoreApiModelsAppReportsPartnerProgramReportResponse> {

    return this.getPartnerProgramReport$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsPartnerProgramReportResponse>) => r.body as BackendCoreApiModelsAppReportsPartnerProgramReportResponse)
    );
  }

  /**
   * Path part for operation getRemainingOrders
   */
  static readonly GetRemainingOrdersPath = '/api/app/report/remaining-orders';

  /**
   * Gets remaining orders report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRemainingOrders$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRemainingOrders$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsRemainingOrderCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetRemainingOrdersPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsRemainingOrderCollectionResponse>;
      })
    );
  }

  /**
   * Gets remaining orders report.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRemainingOrders$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRemainingOrders$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppReportsRemainingOrderCollectionResponse> {

    return this.getRemainingOrders$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsRemainingOrderCollectionResponse>) => r.body as BackendCoreApiModelsAppReportsRemainingOrderCollectionResponse)
    );
  }

  /**
   * Gets remaining orders report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRemainingOrders$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRemainingOrders$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsRemainingOrderCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetRemainingOrdersPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsRemainingOrderCollectionResponse>;
      })
    );
  }

  /**
   * Gets remaining orders report.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getRemainingOrders$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRemainingOrders$Json(params?: {
  }): Observable<BackendCoreApiModelsAppReportsRemainingOrderCollectionResponse> {

    return this.getRemainingOrders$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsRemainingOrderCollectionResponse>) => r.body as BackendCoreApiModelsAppReportsRemainingOrderCollectionResponse)
    );
  }

  /**
   * Path part for operation getSalesReport
   */
  static readonly GetSalesReportPath = '/api/app/report/sales';

  /**
   * Gets sales report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalesReport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getSalesReport$Plain$Response(params: {
    body: BackendCoreApiModelsAppReportsSalesReportRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsSalesReportResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetSalesReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsSalesReportResponse>;
      })
    );
  }

  /**
   * Gets sales report.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSalesReport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getSalesReport$Plain(params: {
    body: BackendCoreApiModelsAppReportsSalesReportRequest
  }): Observable<BackendCoreApiModelsAppReportsSalesReportResponse> {

    return this.getSalesReport$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsSalesReportResponse>) => r.body as BackendCoreApiModelsAppReportsSalesReportResponse)
    );
  }

  /**
   * Gets sales report.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalesReport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getSalesReport$Json$Response(params: {
    body: BackendCoreApiModelsAppReportsSalesReportRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppReportsSalesReportResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppReportBackendService.GetSalesReportPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppReportsSalesReportResponse>;
      })
    );
  }

  /**
   * Gets sales report.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSalesReport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getSalesReport$Json(params: {
    body: BackendCoreApiModelsAppReportsSalesReportRequest
  }): Observable<BackendCoreApiModelsAppReportsSalesReportResponse> {

    return this.getSalesReport$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppReportsSalesReportResponse>) => r.body as BackendCoreApiModelsAppReportsSalesReportResponse)
    );
  }

}
